import React from 'react';
import PropTypes from 'prop-types';
import {Alert} from 'antd';
import classNames from 'classnames';
import {BsChevronLeft} from 'react-icons/bs';
import {useTranslation} from 'react-i18next';


const PageLayout = ({title, subtext, titleProps, error, children, onBack}) => {
  const {t} = useTranslation('authentication');
  const subtextChild = typeof subtext === 'string' ? t(subtext) : subtext;
  return (
    <div className={'auth-content'}>
      <h2 {...titleProps}
        className={classNames('uppercase font-bold mb-3 flex items-center text-xs', titleProps.className)}>
        {onBack && <BsChevronLeft className={'cursor-pointer mr-3'} onClick={onBack}/>}
        {t(title)}
      </h2>
      {subtext && <div className={'mb-4'}>{subtextChild}</div>}
      <div className={'form-container'}>
        {!!error &&
        <Alert className={'mb-4'}
          message={t(error)} type="error" showIcon closable/>
        }
        {children}
      </div>
    </div>
  );
};

export default PageLayout;

PageLayout.defaultProps = {
  titleProps: {}
};
PageLayout.propTypes = {
  children: PropTypes.any,
  error: PropTypes.string,
  onBack: PropTypes.func,
  subtext: PropTypes.any,
  title: PropTypes.string,
  titleProps: PropTypes.object
};
